import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 6c-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6-2.692-6-6-6m0 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m0-16C5.373 0 0 5.373 0 12c0 4.838 1.686 6.189 10.767 19.354a1.5 1.5 0 0 0 2.467 0C22.315 18.189 24.001 16.838 24.001 12c0-6.627-5.373-12-12-12zm0 29.621C3.294 17.031 2 16.031 2 12c0-2.671 1.04-5.182 2.929-7.071S9.329 2 12 2s5.182 1.04 7.071 2.929S22 9.329 22 12c0 4.031-1.293 5.029-10 17.621" }, null, -1)
  ])))
}
export default { render: render }